import {BaseMutation} from '../base-mutation';
import {message} from '@common/i18n/message';

export type ModifyAttributesValues = {
  href?: string | null;
  download?: string | null;
  target?: string | null;
  class?: string;
  style?: string;
  type?: string;
  placeholder?: string;
  rows?: string;
  src?: string;
  action?: string;
  // Omelette widget attributes
  'data-variant'?: string;
  'data-waitlist'?: string;
  'data-title'?: string;
  'data-subtitle'?: string;
  'data-submittext'?: string;
  'data-hasnamefield'?: string;
  'data-hasphonefield'?: string;
  'data-metafields'?: string;
  'data-imgsrc'?: string;
  'data-imglocation'?: string;
  'data-subscribercounttext'?: string;
  // Factory article attributes
  'data-article-id'?: string;
  'data-article-keyword'?: string;
  'data-article-url'?: string;
  // AOS animation attributes
  'data-aos'?: string | null;
  'data-aos-duration'?: string | null;
  'data-aos-delay'?: string | null;
  'data-aos-easing'?: string | null;
  'data-aos-once'?: string | null;
};

export class ModifyAttributes extends BaseMutation {
  displayName = message('Changed element attributes');
  changes: {new: ModifyAttributesValues; old: ModifyAttributesValues} = {
    new: {},
    old: {},
  };
  constructor(
    protected el: HTMLElement,
    newProps: ModifyAttributesValues,
  ) {
    super(el);
    this.changes.new = newProps;
  }

  protected onBeforeExecute() {
    if (this.pageDoc) {
      const el = this.findEl(this.pageDoc);
      if (el) {
        this.changes.old = {};
        Object.keys(this.changes.new).forEach(p => {
          const prop = p as keyof ModifyAttributesValues;
          this.changes.old[prop] = el.getAttribute(prop) ?? undefined;
        });
      }
    }
  }

  protected executeMutation(doc: Document): boolean {
    return this.modifyAttributes(doc, this.changes.new);
  }

  protected undoMutation(doc: Document): boolean {
    return this.modifyAttributes(doc, this.changes.old);
  }

  protected modifyAttributes(doc: Document, props: ModifyAttributesValues) {
    const el = this.findEl(doc);
    if (!el) return false;
    return Object.entries(props)
      .map(([prop, value]) => {
        if (value !== el.getAttribute(prop)) {
          if (value == null) {
            el.removeAttribute(prop);
          } else {
            el.setAttribute(prop, value);
          }
          return true;
        }
      })
      .some(changed => changed);
  }
}
